var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgWalletFilled162 = function SvgWalletFilled162(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#WalletFilled16-2_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M0 6.6c0-.754 0-1.131.234-1.366C.47 5 .846 5 1.6 5h9.15c2.107 0 3.16 0 3.917.506a3 3 0 0 1 .827.827C16 7.09 16 8.143 16 10.25c0 2.107 0 3.16-.506 3.917a3 3 0 0 1-.827.827c-.757.506-1.81.506-3.917.506H6c-2.828 0-4.243 0-5.121-.879C0 13.743 0 12.328 0 9.5V6.6Z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 10,
    r: 1.5,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M8.632 1H2.368A2.368 2.368 0 0 0 0 3.368C0 3.718.283 4 .632 4h9.736A.632.632 0 0 0 11 3.368 2.368 2.368 0 0 0 8.632 1Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "WalletFilled16-2_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h16v16H0z"
  })))));
};
export default SvgWalletFilled162;